/* gg-gift-tag-v27 — Document-level capture-phase apply handler is registered BEFORE the IIFE,
   guaranteeing it fires no matter what happens inside the IIFE. Uses console.error so the
   message can't be filtered out by Default-Levels filters. */

document.addEventListener('click', async function ggApplyDelegate(e) {
  const target = e.target && e.target.closest && e.target.closest('.gg-tag__apply');
  if (!target) return;

  console.error('[gg-gift-tag] APPLY CLICKED via document delegation');

  e.preventDefault();
  e.stopPropagation();
  e.stopImmediatePropagation();

  if (target.dataset.ggApplied === '1') return;
  target.dataset.ggApplied = '1';
  target.classList.add('is-applied');
  const label = target.querySelector('.gg-tag__apply-label');
  if (label) label.textContent = 'Applied';

  const code = target.getAttribute('data-discount-code') || 'WELCOME10';

  // 1. Apply discount via Shopify's /discount/<code> endpoint (no navigation)
  try {
    await fetch('/discount/' + encodeURIComponent(code), {
      credentials: 'same-origin',
      redirect: 'manual',
    });
    console.error('[gg-gift-tag] discount fetch complete');
  } catch (err) {
    console.error('[gg-gift-tag] discount fetch failed:', err);
  }

  // 2. Refresh the cart drawer's INNER content (preserves dialog top-layer state)
  try {
    const drawer = document.querySelector('cart-drawer-component');
    if (!drawer) { console.error('[gg-gift-tag] no cart-drawer-component to refresh'); return; }
    const sectionWrap = drawer.closest('[id^="shopify-section-"]');
    const sectionId = sectionWrap && sectionWrap.id.replace('shopify-section-', '');
    if (!sectionId) { console.error('[gg-gift-tag] no section id'); return; }
    const r = await fetch('/?sections=' + encodeURIComponent(sectionId), { credentials: 'same-origin' });
    const data = await r.json();
    const html = data[sectionId];
    if (!html) { console.error('[gg-gift-tag] empty section html'); return; }
    const doc = new DOMParser().parseFromString(html, 'text/html');
    const newDialog = doc.querySelector('cart-drawer-component dialog');
    const oldDialog = drawer.querySelector('dialog');
    if (newDialog && oldDialog) {
      oldDialog.innerHTML = newDialog.innerHTML;
      console.error('[gg-gift-tag] dialog innerHTML refreshed; drawer should still be open');
    } else {
      console.error('[gg-gift-tag] couldn\'t find dialog to swap', { newDialog, oldDialog });
    }
  } catch (err) {
    console.error('[gg-gift-tag] cart refresh failed:', err);
  }
}, true /* capture: true — fire before anything in the bubble phase */);

console.error('[gg-gift-tag v27] document delegation registered');

(function () {
  'use strict';

  const tag = document.getElementById('GGGiftTag');
  const toast = document.getElementById('GGGiftTagToast');
  if (!tag) return;

  const drawer = document.querySelector('cart-drawer-component');
  const dialog = drawer && drawer.querySelector('dialog');
  if (!drawer || !dialog) return;

  const supportsPopover = typeof tag.showPopover === 'function';

  let openTimer = null;
  let toastTimer = null;
  let alreadyApplied = false;

  /**
   * Geometry contract:
   *  - Tag width = 188px
   *  - Grommet at right:8 with 14px width → grommet centre = card_right - 15
   *  - We want grommet centre at drawer.left (the drawer's outer left edge)
   *  - So card_left = drawer.left - 173, card_top = drawer.top + 110
   */
  function positionTag() {
    const r = dialog.getBoundingClientRect();
    if (r.width === 0) return;
    // Anchor popover root at the drawer's top-left corner (0×0 wrapper).
    // Pin/string/card use positive top + their own left offsets.
    tag.style.left = r.left + 'px';
    tag.style.top  = r.top + 'px';
    // Expose drawer.top as a CSS variable so the pin can sit at viewport y=10
    // regardless of where drawer.top falls (announcement bar, header, etc.).
    tag.style.setProperty('--gg-drawer-top', r.top + 'px');
    if (toast) {
      toast.style.left = (r.left + r.width / 2) + 'px';
      toast.style.bottom = '32px';
      toast.style.transform = 'translateX(-50%) translateY(8px)';
    }
  }

  function rectStr(r) {
    if (!r) return 'null';
    return `{left:${r.left.toFixed(2)}, top:${r.top.toFixed(2)}, width:${r.width.toFixed(2)}, height:${r.height.toFixed(2)}, right:${r.right.toFixed(2)}, bottom:${r.bottom.toFixed(2)}}`;
  }

  function logDiagnostic() {
    try {
      const drawerRect = dialog.getBoundingClientRect();
      const anchorEl = tag.querySelector('.gg-tag-anchor');
      const lineEl = anchorEl && anchorEl.querySelector('line');
      const circleEl = anchorEl && anchorEl.querySelector('circle');
      const cardEl = tag.querySelector('.gg-tag__card');
      const grommetEl = tag.querySelector('.gg-tag__grommet');

      console.group('[gg-gift-tag v8] DOM presence');
      console.log('tag exists                =', !!tag);
      console.log('anchor svg exists         =', !!anchorEl);
      console.log('line element exists       =', !!lineEl);
      console.log('circle element exists     =', !!circleEl);
      console.log('card exists               =', !!cardEl);
      console.log('grommet exists            =', !!grommetEl);
      console.log('anchor.parentNode         =', anchorEl && anchorEl.parentNode);
      console.log('anchor.parentNode === tag =', anchorEl && anchorEl.parentNode === tag);
      console.log('anchor.outerHTML          =', anchorEl && anchorEl.outerHTML.slice(0, 400));
      console.groupEnd();

      console.group('[gg-gift-tag v8] geometry');
      console.log('drawer.rect               =', rectStr(drawerRect));
      console.log('svg.getBoundingClientRect =', rectStr(anchorEl && anchorEl.getBoundingClientRect()));
      console.log('line.getBoundingClientRect=', rectStr(lineEl && lineEl.getBoundingClientRect()));
      console.log('circle.getBoundingClientRect=', rectStr(circleEl && circleEl.getBoundingClientRect()));
      console.log('card.getBoundingClientRect=', rectStr(cardEl && cardEl.getBoundingClientRect()));
      console.log('grommet.getBoundingClientRect=', rectStr(grommetEl && grommetEl.getBoundingClientRect()));
      console.groupEnd();

      if (anchorEl) {
        const cs = getComputedStyle(anchorEl);
        console.group('[gg-gift-tag v8] svg computed style');
        console.log('display       =', cs.display);
        console.log('visibility    =', cs.visibility);
        console.log('opacity       =', cs.opacity);
        console.log('clip-path     =', cs.clipPath);
        console.log('clip          =', cs.clip);
        console.log('transform     =', cs.transform);
        console.log('overflow      =', cs.overflow);
        console.log('position      =', cs.position);
        console.log('z-index       =', cs.zIndex);
        console.log('width / height=', cs.width, '/', cs.height);
        console.log('left / top    =', cs.left, '/', cs.top);
        console.log('color         =', cs.color);
        console.log('fill          =', cs.fill);
        console.log('stroke        =', cs.stroke);
        console.groupEnd();
      }
      if (lineEl) {
        const cs = getComputedStyle(lineEl);
        console.group('[gg-gift-tag v8] line computed style');
        console.log('display    =', cs.display);
        console.log('visibility =', cs.visibility);
        console.log('opacity    =', cs.opacity);
        console.log('stroke     =', cs.stroke);
        console.log('stroke-width=', cs.strokeWidth);
        console.log('stroke-opacity=', cs.strokeOpacity);
        console.log('clip-path  =', cs.clipPath);
        console.groupEnd();
      }
      if (circleEl) {
        const cs = getComputedStyle(circleEl);
        console.group('[gg-gift-tag v8] circle computed style');
        console.log('display    =', cs.display);
        console.log('visibility =', cs.visibility);
        console.log('opacity    =', cs.opacity);
        console.log('fill       =', cs.fill);
        console.log('stroke     =', cs.stroke);
        console.log('clip-path  =', cs.clipPath);
        console.groupEnd();
      }

      console.group('[gg-gift-tag v8] ancestor overflow / clip');
      let el = tag;
      const rows = [];
      while (el && el !== document.documentElement) {
        const cs = getComputedStyle(el);
        rows.push({
          el: el.tagName.toLowerCase() + (el.className && typeof el.className === 'string' ? '.' + el.className.split(' ').slice(0, 2).join('.') : ''),
          overflow: cs.overflow,
          'overflow-x': cs.overflowX,
          'overflow-y': cs.overflowY,
          'clip-path': cs.clipPath,
          isolation: cs.isolation,
          transform: cs.transform === 'none' ? 'none' : '(set)',
          'z-index': cs.zIndex,
          position: cs.position
        });
        el = el.parentElement;
      }
      console.table(rows);
      console.groupEnd();
    } catch (e) {
      console.warn('[gg-gift-tag] diagnostic failed:', e);
    }
  }

  function showTag() {
    // Cancel any in-flight close so re-opening mid-fade doesn't lose state
    clearTimeout(hideTimer);
    tag.classList.remove('is-closing');
    positionTag();
    if (supportsPopover) {
      try { if (!tag.matches(':popover-open')) tag.showPopover(); }
      catch (e) {}
    }
    tag.setAttribute('aria-hidden', 'false');
    requestAnimationFrame(() => {
      tag.classList.add('is-visible');
      // Diagnostic — fires once after the tag is positioned & shown
      setTimeout(logDiagnostic, 50);
    });
  }

  let hideTimer = null;
  function hideTag() {
    clearTimeout(hideTimer);
    // Trigger fade-out animation; defer popover hide until it's done so the
    // tag exits in sync with the cart drawer's slide-out (~350ms).
    tag.classList.remove('is-visible');
    tag.classList.add('is-closing');
    tag.setAttribute('aria-hidden', 'true');
    hideTimer = setTimeout(() => {
      tag.classList.remove('is-closing');
      if (supportsPopover && tag.matches(':popover-open')) {
        try { tag.hidePopover(); } catch (e) {}
      }
    }, 320);
  }

  function showToast() {
    if (!toast) return;
    if (supportsPopover && typeof toast.showPopover === 'function') {
      try { if (!toast.matches(':popover-open')) toast.showPopover(); }
      catch (e) {}
    }
    requestAnimationFrame(() => toast.classList.add('is-visible'));
  }
  function hideToast() {
    if (!toast) return;
    toast.classList.remove('is-visible');
    setTimeout(() => {
      if (supportsPopover && toast.matches(':popover-open')) {
        try { toast.hidePopover(); } catch (e) {}
      }
    }, 320);
  }

  const obs = new MutationObserver(() => {
    if (dialog.hasAttribute('open')) {
      clearTimeout(openTimer);
      openTimer = setTimeout(showTag, 1400);
    } else {
      clearTimeout(openTimer);
      hideTag();
      hideToast();
    }
  });
  obs.observe(dialog, { attributes: true, attributeFilter: ['open'] });

  function reposIfOpen() {
    if (dialog.hasAttribute('open') && tag.matches(':popover-open')) positionTag();
  }
  window.addEventListener('resize', reposIfOpen);
  window.addEventListener('scroll', reposIfOpen, { passive: true });

  /**
   * Apply a discount code by populating the form and clicking its actual
   * submit button — the same path a user takes manually. This avoids:
   *   - Synthetic SubmitEvent that can be intercepted
   *   - Direct method calls that bypass Horizon's setup
   * The button.click() generates a real native submit, Horizon's document-level
   * delegation catches it, and the discount applies normally.
   */
  function applyDiscountCode(code) {
    const cartDiscount = document.querySelector('cart-discount-component');
    if (!cartDiscount) {
      console.warn('[gg-gift-tag] cart-discount-component not found');
      return false;
    }
    const form  = cartDiscount.querySelector('form.cart-discount__form');
    const input = cartDiscount.querySelector('input[name="discount"]');
    const submitBtn = cartDiscount.querySelector('button.cart-discount__button')
                   || cartDiscount.querySelector('button[type="submit"]');
    if (!form || !input || !submitBtn) {
      console.warn('[gg-gift-tag] discount form / input / button missing', { form: !!form, input: !!input, submitBtn: !!submitBtn });
      return false;
    }

    // Open the collapsed <details> wrapper so the populated input is visible.
    const details = cartDiscount.closest('details');
    if (details && !details.open) details.open = true;

    // Populate input
    input.value = code;
    input.dispatchEvent(new Event('input', { bubbles: true }));

    // Click the actual submit button — natural path, exactly what the user
    // would do manually. Triggers a real submit event that Horizon's
    // delegation catches and routes to applyDiscount().
    console.log('[gg-gift-tag] clicking discount submit button with code', code);
    submitBtn.click();
    return true;
  }

  /**
   * Holds the dialog in modal (top-layer) state for the next ~2.5s.
   * Anything that tries to drop it out of :modal — Horizon's morph,
   * outside-click handler, or whatever else — gets undone immediately.
   */
  function lockDialogModalFor(ms) {
    const cartDrawer = document.querySelector('cart-drawer-component');
    const liveDialog = cartDrawer && cartDrawer.querySelector('dialog');
    if (!cartDrawer || !liveDialog) return () => {};

    let active = true;
    let attempts = 0;
    const restore = () => {
      if (!active || attempts > 6) return;
      const drawerNow = document.querySelector('cart-drawer-component');
      const dialogNow = drawerNow && drawerNow.querySelector('dialog');
      if (!drawerNow || !dialogNow) return;
      if (!dialogNow.matches(':modal')) {
        attempts++;
        console.log('[gg-gift-tag] restoring dialog modal state, attempt', attempts);
        try { if (dialogNow.open) dialogNow.close(); } catch (e) {}
        try {
          if (typeof drawerNow.showDialog === 'function') drawerNow.showDialog();
          else dialogNow.showModal();
        } catch (e) {
          console.warn('[gg-gift-tag] restore failed:', e);
        }
      }
    };

    // Re-check on every attribute change to the dialog (open, etc.)
    // AND every 100ms as a belt-and-braces safety net.
    const obs = new MutationObserver(restore);
    obs.observe(liveDialog, { attributes: true });
    const interval = setInterval(restore, 100);

    setTimeout(() => {
      active = false;
      obs.disconnect();
      clearInterval(interval);
    }, ms);

    return () => { active = false; obs.disconnect(); clearInterval(interval); };
  }

  // Pure-AJAX discount apply. No page navigation, no Horizon morph helper,
  // no submit dispatch. Three independent fetches:
  //   1) /discount/<code>  — Shopify sets the discount cookie and replies 302.
  //                          With redirect:'manual' we don't follow it.
  //   2) /?sections=<id>   — fetch the rebuilt cart-drawer section HTML.
  //   3) replace the live <dialog>'s innerHTML with the new content.
  // The <dialog> element ITSELF is never touched, so its top-layer state
  // (showModal) stays intact — drawer doesn't close, no re-open dance needed.
  async function applyDiscountAndRefresh(code) {
    console.warn('[gg-gift-tag] applying discount:', code);

    // 1. Apply the discount
    try {
      await fetch('/discount/' + encodeURIComponent(code), {
        credentials: 'same-origin',
        redirect: 'manual',
      });
    } catch (err) {
      console.warn('[gg-gift-tag] /discount fetch failed:', err);
    }

    // 2. Find the cart-drawer's section so we know what to re-render
    const cartDrawer = document.querySelector('cart-drawer-component');
    if (!cartDrawer) {
      console.warn('[gg-gift-tag] cart-drawer-component not found, refresh skipped');
      return;
    }
    const sectionEl = cartDrawer.closest('[id^="shopify-section-"]');
    const sectionId = sectionEl && sectionEl.id.replace('shopify-section-', '');
    if (!sectionId) {
      console.warn('[gg-gift-tag] could not derive section id from drawer wrapper');
      return;
    }

    // 3. Fetch the rebuilt section and replace dialog innerHTML
    try {
      const sr = await fetch('/?sections=' + encodeURIComponent(sectionId), { credentials: 'same-origin' });
      const data = await sr.json();
      const newHtml = data[sectionId];
      if (!newHtml) {
        console.warn('[gg-gift-tag] section response had no html for', sectionId);
        return;
      }
      const doc = new DOMParser().parseFromString(newHtml, 'text/html');
      const newDialog = doc.querySelector('cart-drawer-component dialog');
      const oldDialog = cartDrawer.querySelector('dialog');
      if (newDialog && oldDialog) {
        oldDialog.innerHTML = newDialog.innerHTML;
        console.warn('[gg-gift-tag] dialog innerHTML refreshed; drawer should still be open');
      } else {
        console.warn('[gg-gift-tag] could not find new or old dialog to swap');
      }
    } catch (err) {
      console.warn('[gg-gift-tag] section refresh failed:', err);
    }
  }

  const apply = tag.querySelector('.gg-tag__apply');
  const applyLabel = tag.querySelector('.gg-tag__apply-label');
  console.warn('[gg-gift-tag] apply button found at script load:', !!apply);
  if (apply) {
    apply.addEventListener('click', async (e) => {
      console.warn('[gg-gift-tag] APPLY CLICKED');
      e.preventDefault();
      e.stopPropagation();
      e.stopImmediatePropagation();

      if (alreadyApplied) return;
      alreadyApplied = true;
      apply.classList.add('is-applied');
      if (applyLabel) applyLabel.textContent = 'Applied';

      const code = apply.getAttribute('data-discount-code') || 'WELCOME10';
      await applyDiscountAndRefresh(code);

      showToast();
      clearTimeout(toastTimer);
      toastTimer = setTimeout(hideToast, 2400);
    });
  }
})();
